import axios from "axios";
import { logout } from "../lib/auth";
import { accountTableColumn } from "../config/account";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

export interface ProfileResponse {
  authority: string;
  account_name: string;
  plan_id: string | null;
  plan_name: string | null;
  max_partners: number | null;
  max_et_sites: number | null;
  has_payment: boolean | null;
  has_ai_analysis: boolean | null;
  current_partners: number;
  current_et_sites: number;
  monthly_price: number | null;
  [key: string]: string | number | boolean | null;
}

// 顧客詳細取得
export async function getProfile(): Promise<ProfileResponse> {
  try {
    const path = "profile";
    const response = await axios.get(CONST.apiUrl + path);
    const detail_data = response.data.detail_data[0] as ProfileResponse;
    return detail_data;
  } catch (error) {
    return {} as ProfileResponse;
    // logout();
  }
}
